import { jordanEssentialsTheme, paparazziTheme, wayrooTheme } from './colors';

// Re-export everything for backward compatibility
export { typography } from './typography';
export {
  wayrooTheme,
  paparazziTheme,
  jordanEssentialsTheme,
  wayrooThemeLight,
} from './colors';

// Layout variables
export const LAYOUT = {
  mobileNavWidth: 288,
  maxBodyWidth: 1920,
};

// Return raw theme configurations (not created themes).
// ThemeWrapper selects one by tenant and flattens the chosen mode's palette
// into createTheme.
const getThemes = (): Record<number, typeof wayrooTheme> => ({
  3: wayrooTheme,
  4: paparazziTheme,
  5: jordanEssentialsTheme,
});

getThemes.default = wayrooTheme;

export default getThemes;
